module.exports = __webpack_public_path__ + "img/range-active.7be75362.svg";